import { AttributeItem } from "src/app/users/_interfaces/users-admin";

export enum AttributeType {
    Company = 1,
    BusinessGroup = 2,
    BusinessUnit = 3,
    Country = 4,
    FrontBackOffice = 5,
    Job = 6,
    Location = 7,
    Rank = 8,
    Sector1 = 9,
    Segment = 10,
    LegalEntity = 11,
    RankOpen = 12,
    Sector2 = 13,
    Sector3 = 14,
    Sector4 = 15,
    Manager = 16,
    Model = 17,
    Head = 18,
}

export type AttributesGroupedByType = {
    [key in AttributeType]?: AttributeItem[];
}

export class ExternalEvaluationFilterTypeEnum {
    public static Creator: ExternalEvaluationFilterTypeEnum = new ExternalEvaluationFilterTypeEnum(1, "externalEvaluation.creator");
    public static Evaluee: ExternalEvaluationFilterTypeEnum = new ExternalEvaluationFilterTypeEnum(2, "generic.evaluee");
    public static Evaluator: ExternalEvaluationFilterTypeEnum = new ExternalEvaluationFilterTypeEnum(3, "generic.evaluator");
    private constructor(
        public type: number,
        public name: string,
    ) { }
}

export class AttributeTypeEnum {
    public static Company: AttributeTypeEnum = new AttributeTypeEnum(1, "Company");
    public static BusinessGroup: AttributeTypeEnum = new AttributeTypeEnum(2, "Business Group");
    public static BusinessUnit: AttributeTypeEnum = new AttributeTypeEnum(3, "Business Unit");
    public static Country: AttributeTypeEnum = new AttributeTypeEnum(4, "Country");
    public static FrontBackOffice: AttributeTypeEnum = new AttributeTypeEnum(5, "FrontBackOffice");
    public static Job: AttributeTypeEnum = new AttributeTypeEnum(6, "Job");
    public static Location: AttributeTypeEnum = new AttributeTypeEnum(7, "Location");
    public static Rank: AttributeTypeEnum = new AttributeTypeEnum(8, "Rank");
    public static Sector1: AttributeTypeEnum = new AttributeTypeEnum(9, "Sector1");
    public static Segment: AttributeTypeEnum = new AttributeTypeEnum(10, "Segment");
    public static LegalEntity: AttributeTypeEnum = new AttributeTypeEnum(11, "Legal Entity");
    public static RankOpen: AttributeTypeEnum = new AttributeTypeEnum(12, "RankOpen");
    public static Sector2: AttributeTypeEnum = new AttributeTypeEnum(13, "Sector2");
    public static Sector3: AttributeTypeEnum = new AttributeTypeEnum(14, "Sector3");
    public static Sector4: AttributeTypeEnum = new AttributeTypeEnum(15, "Sector4");
    public static Manager: AttributeTypeEnum = new AttributeTypeEnum(16, "Manager");
    public static Model: AttributeTypeEnum = new AttributeTypeEnum(17, "Model");
    public static Head: AttributeTypeEnum = new AttributeTypeEnum(18, "Head");

    private constructor(
        public type: number,
        public name: string,
    ) { }

    public static values(): AttributeTypeEnum[] {
        return [
            // AttributeTypeEnum.Company,
            AttributeTypeEnum.BusinessGroup,
            // AttributeTypeEnum.BusinessUnit,
            AttributeTypeEnum.Country,
            // AttributeTypeEnum.FrontBackOffice,
            // AttributeTypeEnum.Job,
            // AttributeTypeEnum.Location,
            // AttributeTypeEnum.Rank,
            // AttributeTypeEnum.Segment,
            // AttributeTypeEnum.LegalEntity,
            // AttributeTypeEnum.RankOpen,
            // AttributeTypeEnum.Sector1,
            // AttributeTypeEnum.Sector2,
            // AttributeTypeEnum.Sector3,
            // AttributeTypeEnum.Sector4
        ];
    }

    public static allValues(): AttributeTypeEnum[] {
        return [
            AttributeTypeEnum.Company,
            AttributeTypeEnum.BusinessGroup,
            AttributeTypeEnum.BusinessUnit,
            AttributeTypeEnum.Country,
            AttributeTypeEnum.FrontBackOffice,
            AttributeTypeEnum.Job,
            AttributeTypeEnum.Location,
            AttributeTypeEnum.Rank,
            AttributeTypeEnum.Sector1,
            AttributeTypeEnum.Segment,
            AttributeTypeEnum.LegalEntity,
            AttributeTypeEnum.RankOpen,
            AttributeTypeEnum.Sector2,
            AttributeTypeEnum.Sector3,
            AttributeTypeEnum.Sector4,
            AttributeTypeEnum.Manager,
            AttributeTypeEnum.Model,
            AttributeTypeEnum.Head,
        ];
    }

    public static get Dictionary(): { [key: number]: AttributeTypeEnum } {
        const dict = {};
        AttributeTypeEnum.allValues().forEach((v) => (dict[v.type] = v));
        return dict;
    }

    public static groupValues(): AttributeTypeEnum[] {
        return [
            AttributeTypeEnum.Company,
            AttributeTypeEnum.BusinessGroup,
            AttributeTypeEnum.BusinessUnit,
            AttributeTypeEnum.Country,
            AttributeTypeEnum.FrontBackOffice,
            AttributeTypeEnum.Job,
            AttributeTypeEnum.Location,
            AttributeTypeEnum.Rank,
            AttributeTypeEnum.Sector1,
            AttributeTypeEnum.Segment,
            AttributeTypeEnum.LegalEntity,
            AttributeTypeEnum.RankOpen,
            AttributeTypeEnum.Sector2,
            AttributeTypeEnum.Sector3,
            AttributeTypeEnum.Sector4,
            AttributeTypeEnum.Manager,
            AttributeTypeEnum.Model,
            AttributeTypeEnum.Head,
        ];
    }
}

export class FilterModel {
    public typeName: string;
    constructor(
        public name: string,
        public items: FilterItem[],
        public isRequired: boolean,
        public multiSelect: boolean,
        public hasSearch = false,
        public isTextarea = false,
    ) {
        this.typeName = "FilterModel";
    }
    public get totalSelected(): number {
        return this.items.filter((x) => x.selected).length;
    }

    public toggleSelectItem(index: number) {
        const item = this.items[index];
        if (!this.multiSelect) {
            for (const it of this.items) {
                if (it.value !== item.value) it.selected = false;
            }
        }
        if (!item.selected || (item.selected && !this.isRequired)) item.selected = !item.selected;
    }

    public clear() {
        for (const i of this.items) {
            i.selected = false;
        }
    }
}

export class DateFilter extends FilterModel {
    constructor(
        public name: string,
        public items: FilterItem[],
        public calibrationGroupId?: number,
    ) {
        super(name, items, false, false, false);
        this.typeName = "DateFilter";
    }

    public clear() {
        for (const i of this.items) {
            i.selected = false;
            i.value = "";
        }
    }
}

export class AttributeFilter extends FilterModel {
    constructor(
        public type: AttributeTypeEnum,
        public items: FilterItem[],
        public multiSelect: boolean,
        public onlyAccessible = false,
        public calibrationGroupId?: number,
    ) {
        super("filters." + type.name.replace(/\s/g, ""), items, false, multiSelect, true);
        this.typeName = "AttributeFilter";
    }
}

export class ExternalEvaluationFilter extends FilterModel {
    constructor(
        public type: ExternalEvaluationFilterTypeEnum,
        public items: FilterItem[],
        public multiSelect: boolean,
    ) {
        super(type.name, items, false, multiSelect, true);
        this.typeName = "ExternalEvaluationFilter";
    }
}

export class ParticipantNameFilter extends FilterModel {
    constructor(
        public items: FilterItem[],
        public multiSelect: boolean,
        public calibrationGroupId?: number,
    ) {
        super("ninebox.searchQuadrantParticipant", items, false, multiSelect, true);
        this.typeName = "ParticipantNameFilter";
    }
}

// export class LocationFilter extends FilterModel {
//     constructor(public name: string, public items: FilterItem[]) { super(name, items); }
// }

export class FilterItem {
    constructor(
        public id: string,
        public name: string,
        public value: string,
        public selected = false,
        public type = 0,
    ) { }
}

export class AttributeFilterItem extends FilterItem {
    constructor(
        public name: string,
        public value: string,
        public selected = false,
        public type = 0,
    ) {
        super("attributeIds", name, value, selected, type);
    }
}
